import React from 'react';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { openTawktrikChat } from '../utils/chatUtils';
import { howItWorks } from '../mock';
import { FileText, CreditCard, CheckCircle } from 'lucide-react';

const iconComponents = {
  FileText,
  CreditCard,
  CheckCircle
};

const HowItWorksSection = ({ onOpenModal }) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#FFB400] uppercase tracking-wide mb-2">
            How It Works
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2B0A12] mb-4">
            Simple 3-Step Process
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Protecting your trademark has never been easier. Follow our streamlined process to secure your intellectual property rights.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {howItWorks.map((step, index) => {
            const IconComponent = iconComponents[step.icon];
            return (
              <div key={step.id} className="relative">
                {/* Connector Line */}
                {index < howItWorks.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#FFB400] to-[#D72638]"></div>
                )}
                
                <div className="text-center relative z-10">
                  <div className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-[#2B0A12] to-[#3D1C24] rounded-full mb-6 shadow-xl">
                    <IconComponent className="h-12 w-12 text-[#FFB400]" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#2B0A12] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-700 mb-6">
            Ready to protect your brand? Start your trademark registration today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - How It Works Section')}
              className="bg-[#FFB400] hover:bg-[#e5a200] text-[#2B0A12] font-semibold px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              Start Trademark Registration
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={openTawktrikChat}
              className="border-2 border-[#D72638] text-[#D72638] hover:bg-[#D72638] hover:text-white font-semibold px-8 py-6 rounded-lg transition-all duration-300 hover:scale-105"
            >
              Discuss with Attorney
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;